import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Why is Regulatory Affairs important in healthcare?",
    category: "Technology",
    description:
      "Regulatory Affairs protects public safety by ensuring drugs, medical devices, and biologics meet strict quality, safety, and efficacy standards. It helps companies avoid legal risks, product recalls, and ensures successful market approvals.",
  },
  {
    title: "What does a Regulatory Affairs Specialist do?",
    category: "Trending",
    description:
      "A Regulatory Affairs Specialist prepares submissions, maintains compliance documentation, monitors global regulations, coordinates with R&D teams, and communicates with authorities like FDA or EMA to secure product approvals and maintain regulatory compliance.",
  },
  {
    title: "What qualifications are required for a career in Regulatory Affairs?",
    category: "Design",
    description:
      "A background in pharmacy, biotechnology, life sciences, chemistry, or medical fields is preferred. Certification or training in regulatory affairs strengthens understanding of guidelines, documentation, submission processes, and industry regulations.",
  },
  {
    title: "How important is documentation in Regulatory Affairs?",
    category: "Design",
    description:
      "Documentation is crucial as every product detail must be recorded accurately. Regulatory Affairs manages precise submissions, risk assessments, clinical data, manufacturing details, and updates to meet strict governmental requirements.",
  },
  {
    title: "How does Regulatory Affairs ensure product safety?",
    category: "Design",
    description:
      "They review scientific data, assess risks, ensure manufacturing compliance, monitor post-market reports, and communicate safety updates to authorities. This continuous oversight minimizes risks to patients and end users.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
